// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ap-list-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: var(--planeed-color-white);
  overflow: hidden;
}

.modal-header {
  position: relative;
  z-index: 10;
}

h3 {
  font-family: var(--ion-font-family), serif;
  font-size: 18px;
  color: #00373D;
  width: 80%;
  text-align: center;
  margin: 25px auto;
}

ion-content {
  height: 100%;
  --padding-bottom: 10rem;
}

.search-container {
  border-radius: 10px;
  border: 1px solid #9B9B9B;
  margin-left: 12px;
  margin-right: 12px;
  margin-bottom: 15px;
}

ion-searchbar.custom {
  padding: 0;
  --background: #ffffff;
  --color: #9B9B9B;
  --placeholder-color: #9B9B9B;
  --icon-color: #9B9B9B;
  --border-radius: 10px;
  font-size: 18px;
}

ion-searchbar.md.custom {
  --box-shadow: 0;
  --border: 1px;
}

.scroll-container {
  overscroll-behavior: contain;
  height: 100%;
  --padding-bottom: 2rem;
  --background: var(--planeed-color-white);
}

.action-point-list {
  flex: 1;
  overscroll-behavior: contain;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;
  background-color: var(--planeed-color-white);
  -webkit-overflow-scrolling: touch;
  margin-bottom: 30px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
